import { useIsFetching } from "@tanstack/react-query";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const isFetching = useIsFetching({ queryKey: ["page-data"] }) > 0;

  useEffect(() => {
    if (isFetching) {
      window.scrollTo(0, 0);
    }
  }, [pathname, isFetching]);

  return null;
}
